module.exports = __webpack_public_path__ + "img/example-employee-month-arrows.844c4a78.png";